import { Chip } from '@mui/material';
import { CuriosityNamespaceType, CuriosityTranslation, CuriosityValue } from '@procureai/curiosity-ui-mui';
import { identity } from 'ramda';

import { UserAvatar } from '~/components/UserAvatar/UserAvatar';

export type CuriosityUserChipProps = {
  ns?: CuriosityNamespaceType;
  userId: string;
};

export const CuriosityUserChip = ({ ns, userId }: CuriosityUserChipProps) => (
  <CuriosityValue ns={ns ?? CuriosityNamespaceType.USER} i18nKey={userId} valueGetter={identity}>
    {(val) => {
      const user = val as CuriosityTranslation<{ firstName: string; lastName: string; email: string }>;
      return <Chip key={userId} avatar={<UserAvatar user={user.entity} />} label={user.value} variant="outlined" />;
    }}
  </CuriosityValue>
);
